import React from 'react';
import styled from 'styled-components/macro';
import Drawer from '../components/Drawer';
import BuscadorMobile from '../components/BuscadorMobile';
import { useIsDesktopReal } from '../hooks/useMediaQuery';
import { NotificationButton } from '../components/NotificationButton';
import DropdownHistorico from './DropdownHistorico';
import DatosDeEnvio from './DatosDeEnvio';
import { responsive } from '../resources/constantes.json';
import { getColorOfElec } from '../commons/js/util.js';
import ResultsGeneralData from '../components/ResultsGeneralData';
import MenuIconStatic from '../assets/img/MenuIconStatic.svg';
import HeaderTitle from '../components/Headers/HeaderTitle/index';

/**
 * Header (cabecera) que se muestre al inicio de cada página  que nos informa de la
 * página a la que hemos accedido
 */

const Header = ({ variant, ...rest }) => {
  switch (variant) {
    case 'resultados':
      return <HeaderResultados {...rest} />;
    case 'estadisticas':
      return <HeaderEstadisticas {...rest} />;
    case 'home':
      return <HeaderHome {...rest} />;
    default:
      throw new Error();
  }
};

const HeaderResultados = ({
  nomenclator,
  eleccion,
  children,
  page,
  data,
  ambito,
  esHistorico,
  urlInfo,
}) => {
  const ColorPrimeraFila = esHistorico ? '#646464' : '#1C283D';

  return (
    <>
      <ContenedorPrimeraFila ColorPrimeraFila={ColorPrimeraFila}>
        {esHistorico ? (
          <SHeadingPagina>{children}</SHeadingPagina>
        ) : (
          <>
            <HambuguesaNombre>
              <SCajaHamburguesa>
                <Drawer icon={<img src={MenuIconStatic} alt="Menu Icon"c height={44} />} page={page} />
              </SCajaHamburguesa>
              <SHeadingPagina>{children}</SHeadingPagina>
            </HambuguesaNombre>
            {!esHistorico && (
              <>
                <HeaderRightMobile>
                  <HeaderRight>
                    <NotificationButton nomenclator={nomenclator} />
                    <BuscadorMobile
                      nomenclator={nomenclator}
                      eleccion={eleccion}
                      ambito={ambito}
                      page={page}
                    />
                  </HeaderRight>
                </HeaderRightMobile>
                <HeaderRightDesktop>
                  <HeaderRight>
                    <DatosDeEnvio datoFecha={data.mdhm} />
                    <DropdownHistorico
                      data={data}
                      items={data.historico}
                      ambito={ambito}
                      id={ambito.i}
                      eleccion={eleccion}
                      nomenclator={nomenclator}
                      page={page}
                      tope={data.tope}
                      {...urlInfo}
                    />
                  </HeaderRight>
                </HeaderRightDesktop>
              </>
            )}
          </>
        )}
      </ContenedorPrimeraFila>

      <ContenedorSegundaFila>
        <ContenedorInfoMesas>
          <ResultsGeneralData>
            {esHistorico ? (
              <></>
            ) : (
              <DropdownHistorico
                data={data}
                items={data.historico}
                ambito={ambito}
                id={ambito.i}
                eleccion={eleccion}
                nomenclator={nomenclator}
                page={page}
                tope={data.tope}
                {...urlInfo}
              />
            )}
          </ResultsGeneralData>
        </ContenedorInfoMesas>
      </ContenedorSegundaFila>
    </>
  );
};

const HeaderEstadisticas = ({
  nomenclator,
  eleccion,
  page,
  ambito,
  esHistorico,
  data,
}) => {
  const isDesktop = useIsDesktopReal();
  const colorElec = getColorOfElec(page, nomenclator);
  const ColorPrimeraFila = esHistorico ? '#646464' : '#1C283D';
  const nomAmbitos = nomenclator.nomAmbitos[eleccion];

  return (
    <>
      {!isDesktop && (
        <ContenedorPrimeraFila ColorPrimeraFila={ColorPrimeraFila}>
          <>
            <HambuguesaNombre>
              <SCajaHamburguesa>
                <Drawer icon={<img src={MenuIconStatic} alt="Menu Icon" height={44} />} page={page} />
              </SCajaHamburguesa>
              <HeaderTitle
                title={nomAmbitos.n}
                subtitle={'ESTADÍSTICAS'}
                color={colorElec}
                marginBottom={'0'}
              />
            </HambuguesaNombre>
            {!esHistorico && (
              <HeaderRight>
                <SCajaNotificacion
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <NotificationButton nomenclator={nomenclator} />
                </SCajaNotificacion>
              </HeaderRight>
            )}
          </>
        </ContenedorPrimeraFila>
      )}
    </>
  );
};

const HeaderHome = ({ nomenclator, eleccion, page, ambito, esHistorico }) => {
  const ColorPrimeraFila = esHistorico ? '#646464' : '#1C283D';

  return (
    <ContenedorPrimeraFila ColorPrimeraFila={ColorPrimeraFila}>
      {esHistorico ? (
        <SHeadingPagina>
          {
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <HeaderResultadosBarColorMobile colorElec={'#215CCC'} />
              <p
                style={{
                  color: '#164192',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  fontSize: '2rem',
                }}
              >
                {ambito.n}
              </p>
            </div>
          }
        </SHeadingPagina>
      ) : (
        <>
          <HambuguesaNombre>
            <SCajaHamburguesa>
              <Drawer icon={<img src={MenuIconStatic} alt="Menu Icon" height={44} />} page={page} />
            </SCajaHamburguesa>
            <HeaderTitle
              title={ambito.n}
              color={'#215CCC'}
              marginBottom={'0'}
              withDropdown={false}
            />
          </HambuguesaNombre>
          {!esHistorico && (
            <>
              <HeaderRightMobile>
                <HeaderRight>
                  <NotificationButton nomenclator={nomenclator} />
                  <BuscadorMobile
                    nomenclator={nomenclator}
                    eleccion={eleccion}
                    ambito={ambito}
                    page={page}
                  />
                </HeaderRight>
              </HeaderRightMobile>
            </>
          )}
        </>
      )}
    </ContenedorPrimeraFila>
  );
};

export default Header;

const SCajaHamburguesa = styled.div`
  display: none;
  flex: 0 0 44px;
  height: 44px;
  border-radius: 20px;

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    flex: 0 0 50px;
    height: 50px;
    border-radius: 0;
  }

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    display: block;
  }
`;

const HeadingPagina = props => <h1 data-testid="heading" {...props} />;

const SHeadingPagina = styled(HeadingPagina)`
  font-weight: 500;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 14px;
  min-width: 187px;
  width: 100%;
`;

const SCajaNotificacion = styled.div``;

// HEARDER RESPONSIVE
const ContenedorPrimeraFila = styled(({ ColorPrimeraFila, ...rest }) => (
  <div {...rest} />
))`
  width: 100%;
  display: flex;
  //height: 94px;
  height: fit-content;
  display: flex;
  align-items: center;
  background: #fff;
  justify-content: space-between;
  box-sizing: border-box;
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    box-shadow: 0px 2px 2px 2px rgb(0, 0, 0, 0.16);
    background-color: #f5f8fd;
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 1999;
  }
`;

const ContenedorSegundaFila = styled(({ ...rest }) => <div {...rest} />)`
  display: none;
  min-height: 51px;
  grid-template-columns: 1fr auto;
  padding-left: 0px;
  // box-sizing: border-box;
  // background: #fff;
  justify-content: space-between;
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    display: grid;
    margin-top: 2rem;
  }
`;

const ContenedorInfoMesas = styled.div`
  margin-left: 10px;
  @media (max-width: 1023px) {
    margin-left: 0;
  }
`;

const HambuguesaNombre = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    gap: 1.6rem;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
`;

const HeaderRightMobile = styled.div`
  display: none;

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    display: block;
  }
`;

const HeaderRightDesktop = styled.div`
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    display: none;
  }
`;

// header
const HeaderResultadosBarColorMobile = styled.div`
  width: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  height: 5rem;
  flex-shrink: 0;
  background: ${props => (props.colorElec ? props.colorElec : '#222')};
`;
